import React from 'react'
import CommonPage from './CommonPage';

export default function ShareWithPage() {
  return (
    <>
    <CommonPage name={'sharedWith'} />
    </>
  )
}
